import React from "react";
import Settings from "../settings";

const bannerStyle: React.CSSProperties = {
  backgroundColor: "#b71c1c",
  color: "white",
  textAlign: "center",
  padding: "8px",
  fontWeight: "bold",
};

const NonProductionBanner: React.FC = () => {
  if (!Settings.nonProd) return null;

  return (
    <div style={bannerStyle}>
      Test environment ONLY. Go to
      {" "}
      <a href="https://app.havenconnect.com/properties" style={{ color: "white", textDecoration: "underline" }}>
        havenconnect.com
      </a>
      {" "}
      to find and apply for housing.
    </div>
  );
};

export default NonProductionBanner;
